import React, { useEffect, useState } from "react";
import PageTitle from "../../../layouts/PageTitle";

const FaqDashboard = () => {

  const [faqs, setFaqs] = useState([]);
  const [form, setForm] = useState({
    question: "",
    answer: "",
  });

  useEffect(() => {
    fetchFaqs();
  }, []);

  const fetchFaqs = async () => {
    const res = await fetch("/backend/faqs");
    const data = await res.json();
    setFaqs(data);
  };

  // ADD
  const handleSubmit = async (e) => {
    e.preventDefault();

    await fetch("/backend/faqs", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(form),
    });

    setForm({ question: "", answer: "" });
    fetchFaqs();
  };

  // DELETE
  const handleDelete = async (id) => {
    await fetch(`/backend/faqs/${id}`, {
      method: "DELETE",
    });

    setFaqs(faqs.filter((item) => item.id !== id));
  };

  return (
    <>
      <PageTitle activeMenu="FAQ" motherMenu="Dashboard" />

      <div className="row">

        {/* ADD FAQ */}
        <div className="col-xl-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Add FAQ</h4>
            </div>

            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">

                  <div className="col-md-6 mb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Question"
                      value={form.question}
                      onChange={(e) =>
                        setForm({ ...form, question: e.target.value })
                      }
                      required
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <button className="btn btn-primary w-100">
                      Add FAQ
                    </button>
                  </div>

                  <div className="col-md-12">
                    <textarea
                      className="form-control"
                      rows="4"
                      placeholder="Answer"
                      value={form.answer}
                      onChange={(e) =>
                        setForm({ ...form, answer: e.target.value })
                      }
                      required
                    ></textarea>
                  </div>

                </div>
              </form>
            </div>
          </div>
        </div>

        {/* LIST */}
        <div className="col-xl-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">All FAQs</h4>
            </div>

            <div className="card-body">

              {faqs.length === 0 ? (
                <p>No FAQs available</p>
              ) : (
                <div className="accordion">

                  {faqs.map((item, index) => (
                    <div className="card mb-2" key={item.id}>

                      <div className="card-body">

                        <h5>{item.question}</h5>
                        <p>{item.answer}</p>

                        <button
                          onClick={() => handleDelete(item.id)}
                          className="btn btn-danger btn-sm"
                        >
                          Delete
                        </button>

                      </div>

                    </div>
                  ))}

                </div>
              )}

            </div>
          </div>
        </div>

      </div>
    </>
  );
};

export default FaqDashboard;